import { Badge, Group, Paper, Table, Text, Title } from "@mantine/core";
import { formatDate } from "../../lib/format";
import { SortableTh, useTableSort } from "../ui";

interface SubmissionItem {
  submission_id: string;
  job_title: string | null;
  company_name: string | null;
  status: string;
  created_at: string;
}

export function ProfileRelatedEntities({ submissions }: { submissions: SubmissionItem[] }) {
  const { sorted, sortKey, direction, toggle } = useTableSort(submissions, {
    job: (item) => item.job_title,
    company: (item) => item.company_name,
    status: (item) => item.status,
    created: (item) => new Date(item.created_at),
  });

  return (
    <Paper withBorder p="md">
      <Title order={5} mb="md">
        Related submissions
      </Title>
      {submissions.length === 0 ? (
        <Text c="dimmed">No submissions yet.</Text>
      ) : (
        <Table verticalSpacing="md" highlightOnHover striped>
          <Table.Thead>
            <Table.Tr>
              <SortableTh columnKey="job" sortKey={sortKey} direction={direction} onSort={toggle}>
                Job
              </SortableTh>
              <SortableTh columnKey="company" sortKey={sortKey} direction={direction} onSort={toggle}>
                Company
              </SortableTh>
              <SortableTh columnKey="status" sortKey={sortKey} direction={direction} onSort={toggle}>
                Status
              </SortableTh>
              <SortableTh columnKey="created" sortKey={sortKey} direction={direction} onSort={toggle}>
                Created
              </SortableTh>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {sorted.map((item) => (
              <Table.Tr key={item.submission_id}>
                <Table.Td>{item.job_title ?? "—"}</Table.Td>
                <Table.Td>{item.company_name ?? "—"}</Table.Td>
                <Table.Td>
                  <Group gap="var(--axio-unit-6)">
                    <Badge variant="outline" color="gray">
                      {item.status}
                    </Badge>
                  </Group>
                </Table.Td>
                <Table.Td>{formatDate(item.created_at)}</Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      )}
    </Paper>
  );
}
